import { http, createConfig } from 'wagmi'
import { base } from 'wagmi/chains'

export const WagmiConfig = createConfig({
  chains: [base],
  transports: {
    [base.id]: http(),
  },
})